export default __webpack_public_path__ + "static/media/1622.c7c61a83.png";